import React, { useEffect } from 'react'
import { useRemoteStrings, useAnalyticsClient } from '@acorns/web-utils'
import {
  DrawerBannerDescription,
  DrawerBannerTitle,
  StyledEarnRewardIcon,
  StyledDrawerBanner,
  TermsAndConditions,
} from '../styled-components'
import {
  trackRegistrationPromoCodeEligibilityDrawerViewedPayload,
  trackRegistrationPromoCodeTermsAndConditionsLinkTappedPayload,
} from 'generated/trackingEvents'
import { translateEventProps } from 'utils/analytics'

interface Props {
  appliedPromoCode: string
  description: string
  lastValidPromoCode: string
  termsUrl: string | null
}

export const DrawerBanner = ({
  appliedPromoCode,
  description,
  lastValidPromoCode,
  termsUrl,
}: Props) => {
  const { getRemoteString } = useRemoteStrings()
  const analytics = useAnalyticsClient()

  const handleClick = () => {
    const [eventName, payLoad] = trackRegistrationPromoCodeTermsAndConditionsLinkTappedPayload({
      promotion: appliedPromoCode,
      url: termsUrl,
    })

    analytics.track(eventName, translateEventProps(payLoad))
  }

  useEffect(() => {
    const [eventName, payLoad] = trackRegistrationPromoCodeEligibilityDrawerViewedPayload({
      promotion: appliedPromoCode,
      url: termsUrl,
    })

    analytics.track(eventName, translateEventProps(payLoad))
  }, [])

  return (
    <StyledDrawerBanner>
      <DrawerBannerTitle>
        <StyledEarnRewardIcon />
        {appliedPromoCode
          ? getRemoteString({
              key: 'create_account.promo_code_drawer.promo_applied.variable',
              variables: [appliedPromoCode],
            })
          : getRemoteString({
              key: 'create_account.promo_code_drawer.use_code.variable',
              variables: [lastValidPromoCode],
            })}
      </DrawerBannerTitle>
      <DrawerBannerDescription>{description}</DrawerBannerDescription>
      {!!termsUrl && (
        <TermsAndConditions href={termsUrl} target="_blank" rel="noreferrer" onClick={handleClick}>
          {getRemoteString({
            key: 'create_account.promo_code_drawer.terms_and_conditions.variable.markdown',
          })}
        </TermsAndConditions>
      )}
    </StyledDrawerBanner>
  )
}
